exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.rounded{border-collapse:separate;border-spacing:0}table.rounded,table.rounded tr,table.rounded td{border-width:.5px}table.rounded tr:first-child td:first-child{border-top-left-radius:.25rem}table.rounded tr:first-child td:last-child{border-top-right-radius:.25rem}table.rounded tr:last-child td:first-child{border-bottom-left-radius:.25rem}table.rounded tr:last-child td:last-child{border-bottom-right-radius:.25rem}.payment-statuses-modal{max-width:600px;width:100%}.payment-statuses-modal-badge-width{max-width:105px;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/payment-processing/modals/modals.scss
// module id = 5959
// module chunks = 0